
import { Component, OnChanges, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { EmailTemplate } from 'app/models/dto/email-template.model';

@Component({
    selector: 'app-template-picker',
    templateUrl: './template-picker.component.html',
    styleUrls: ['./template-picker.component.scss'],
    standalone: false
})
export class TemplatePickerComponent implements OnChanges {

  @Input() templates: EmailTemplate[];
  @Input() selectedTemplate: string;
  @Input() affiliateId;
  @Output() chooseTemplate = new EventEmitter<object>();

  canViewNewTemplates: boolean;
  templateGroupNames: string[] = [];
  selectedTemplateGroup: EmailTemplate[];
  templateGroups: { [key: string]: EmailTemplate[] } = {};
  selectedGroup: string;
  typeLabel = {
    user: 'my templates'
  };


  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.templatesHaveChanged(changes);
  }

  templatesHaveChanged(changes: SimpleChanges): void {
    if (changes.templates) {
      this.templateGroups = this.setTemplateGroups(); // Order the templates into {"team": template[], etc...}
      this.templateGroupNames = Object.keys(this.templateGroups).sort(); // Names used on the tabs: ["...", "...", etc...]
      this.selectedGroup = this.templateGroupNames[0];  // Set initial group selection to "all"
      this.selectedTemplateGroup = this.templateGroups[this.selectedGroup];
    }
  }

  setTemplateGroups() {
      return this.templates.filter(template => {
        const templateForOtherAffiliate = template.affiliate && template.affiliate.affiliateId !== this.affiliateId;
        const rejected = template.isAutomated || templateForOtherAffiliate;
        return !rejected;
      }).reduce((groups, template) => {
        let groupName = template.type === 'affiliate'
          ? template.affiliate.name
          : this.typeLabel[template.type] || template.type;
        groupName = groupName?.toLowerCase();

        if (!groups[groupName]) {
          groups[groupName] = [];
        }
        groups[groupName].push(template);

        return groups;
      }, {});
  }

  emitTemplate(template) {
    this.chooseTemplate.emit(template);
  }

  selectedGroupName(group) {
    this.selectedGroup = group;
    this.selectedTemplateGroup = this.templateGroups[this.selectedGroup];
  }
}
